// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1QZlR","rightAdornment":"Header_rightAdornment__2wD5K"};